import { createApi } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from '../axiosBaseQuery';

export interface ChildCollectionOptionResponse {
  Id: number;
  Name: string;
  Text: string;
  RequiredMaximumAge: number;
  RequiredMinimumAge: number;
}

export interface ChildCollectionOption {
  id: number;
  name: string;
  text: string;
  requiredMaximumAge: number;
  requiredMinimumAge: number;
}

export const childCollectionOptionsApi = createApi({
  reducerPath: 'childCollectionOptionsApi',
  baseQuery: axiosBaseQuery({
    baseUrl: '/web-api/api',
  }),
  endpoints: (builder) => ({
    getChildCollectionOptions: builder.query<ChildCollectionOption[], void>({
      query: () => ({
        url: `/examregistation/childCollectionOptions`,
        method: 'get',
      }),
      transformResponse: (options: ChildCollectionOptionResponse[]) =>
        options.map(mapResponse),
    }),
    getSpecificChildCollectionOptions: builder.query<ChildCollectionOption, number>({
      query: (id) => ({
        url: `/examregistation/childCollectionOptions/${id}`,
        method: 'get',
      }),
      transformResponse: mapResponse,
    }),
  }),
});

export const { useGetChildCollectionOptionsQuery, useLazyGetSpecificChildCollectionOptionsQuery } = childCollectionOptionsApi;

//Helpers
function mapResponse(option: ChildCollectionOptionResponse) {
  return {
    id: option.Id,
    name: option.Name,
    text: option.Text,
    requiredMaximumAge: option.RequiredMaximumAge,
    requiredMinimumAge: option.RequiredMinimumAge,
  };
}
